export default __webpack_public_path__ + "static/media/clock.438b6fc2.svg";